// filepath: /Users/rafaeluribe/HTML/InterBotMe/app/src/App.vue
<template>
  
  <div id="app-container">
    <router-view></router-view>
  </div>

</template>

<script>
import AuthService from '@/services/auth.service';
export default {
  data() {
    return {
      user: null,
    };
  },
  async created() {
    this.user = await AuthService.getCurrentUser();
  },
  methods: {
      async logout(){
          await AuthService.signOutUser()
          this.user = null;
          this.$router.push('/login')
      }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@500&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');

#app-container {
  min-height: 100vh;
  background-color: #f9f9f9;
  /* Aquí puedes definir el color de fondo que desees */
}

</style>